/**
 * @generated SignedSource<<9bf35de890b895e91ed7afee4671de54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project$data = {
  readonly projectId: string | null;
  readonly " $fragmentType": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project";
};
export type footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project$key = {
  readonly " $data"?: footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "footerActions_AtlassianConversationAssistantPreviewCard_PreviewFooterActions_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "9fa2aba307f6184ef940fa0abbe53f0a";

export default node;
